export default "__VITE_ASSET__BO4HzSK$__"